
<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>文法檢查工具的應用程式介面（API）</h1>
                        <h2>簡單、快速的AI文法檢查應用程式介面（API）</h2>
                        <p>Trinka人工智慧文法檢查透過簡單的RESTful API在您的應用程式中啟用強大的即時或被動語法檢查。</p>
                        <button type="button" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons">聯繫我們</button>
                        <a href="#sampleCode"  data-toggle="modal" data-target="#sampleCode" id="autoEditGetStart" class="cta-outline-btn m25">示例代碼</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                        <img src="../../../assets/images/trinka-api.svg" alt="Grammar Check API">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section mt-40">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="most_united_heading">
                    <h2>
                        <span></span>為定制應用程式提供獨一無二的集成功能</h2>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="most_suited_point">
                    <ul>
                        <li>內容管理系統</li>
                        <li>線上寫作平台</li>
                        <li>消息應用程式/社交平台</li>
                        <li>客戶關係管理及輔助軟體</li>
                        <li>電子郵件客戶端</li>
                        <li>專案管理軟體</li>
                        <li>電子學習平台</li>
                        <li>學習管理系統</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection mb-0 bg-white">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading mb-0">
                    <h2>Trinka應用程式介面（API）允許您選擇文件或檔案</h2>
                    <div class="HeadingSubLine"></div>
                    <p class="mb-0">透過應用程式介面（API）實現Trinka文法檢查的無縫集成，滿足您的工作流程和技術要求。</p>
                </div>
            </div>
        </div>
    </div>
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_left">
                        <h3>即時檢查應用程式介面（API）</h3>
                        <p>Trinka的即時檢查能大幅提升那些需要進行即時寫作更正的應用程式的功能，比如學習平台、編輯器、聊天應用程式。</p>
                        <ul>
                            <li>靈活地傳遞行、段落或更大的文本集合</li>
                            <li>對所有輸入格式的簡單回應</li>
                            <li>按文本量或應用程式介面（API）調用量來靈活支付</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_right">
                        <img src="../../../assets/images/Real-time Check API.svg" alt="Real-time Check API" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections" style="padding-top: 0;">
        <div class="container">       
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_left">
                        <h3>檔案編輯應用程式介面（API）</h3>
                        <p>Trinka的檔案編輯應用程式介面（API）可以滿足您獨特的工作流程需求，同時避免複雜的集成和大量的API調用。</p>
                        <ul>
                            <li>使用單個應用程式介面（API）調用獲取編輯過的檔案</li>
                            <li>版本控制和用戶控制的追踪修訂</li>
                            <li>為寫作品質打分並且編寫修訂總結</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_right">
                        <img src="../../../assets/images/file-edit-api.png" alt="File-edit API" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection mb-0 bg-light-purple">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading">
                    <h2>由Trinka文法檢查應用程式介面（API）提供支持的應用範例</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>電子學習應用</h3>
                    </div>
                    <p>Trinka文法檢查應用程式介面（API）已經幫助應用程式開發人員完善電子學習課程，滿足學術出版標準。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>出版與編輯</h3>
                    </div>
                    <p>Trinka的文法檢查應用程式介面（API）可以輔助編輯人員更正文本，保證品質的同時節省人力成本。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>學生論壇</h3>
                    </div>
                    <p>得益於Trinka文法檢查應用程式介面（API）的強大檢查能力，學生們能夠在論壇和小組進行有效交流，提高學生參與度。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>企業</h3>
                    </div>
                    <p>Trinka的文法檢查應用程式介面（API）能使多個團隊在不犧牲清晰度、一致性或品牌認知度的情況下，實現更好的寫作。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>生產力平台</h3>
                    </div>
                    <p>Trinka的即時應用程式介面（API）為生產力平台提供獨特的寫作幫助，幫助用戶提高效率。</p>
                </div>
            </div>

            <!-- <div class="col-lg-4 col-md-6">
                <div class="features_cards commingSoonTag">
                    <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area document">
                    <h3>Subject Area & Document Type</h3>
                    <p>Customize Trinka to provide you the most relevant suggestions based on your subject area and
                        type of manuscript.</p>
                </div>
            </div> -->

        </div>
        
    </div>
</div>

<div class="use_trinka_other_app accomplishBrilliantWrap mt-0">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="accomplishBrilliantSection">
                    <h2>瞭解Trinka文法檢查工具應用程式介面（API）如何為您服務。</h2>
                    <a (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons pointer">聯繫我們</a>
                </div>
            </div>
        </div>
            
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection cs-section">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading mb-3">
                    <h2>使用簡單的應用程式介面（API）訪問Trinka的所有功能</h2>
                    <div class="HeadingSubLine"></div>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 col-xl-5">
                <div class="cs-left-section">
                    <p>Trinka的文法檢查應用程式介面（API）為您提供全面的寫作幫助，從高級英語文法更正到語調和風格增強。您可以隨時挑選適合需求的功能！</p>

                    <p>Trinka的文法和拼寫檢查應用程式介面（API）將改進您的寫作方式，使其符合學術寫作慣例和最佳實踐，同時也能讓您更專注於學術創新。</p>

                    <p>Trinka的文法檢查工具應用程式介面（API）還提供其他功能，如技術短語、學術語調、無偏見的語言、單詞選擇、用法和樣式等。</p>
                </div>
            </div>
            <div class="col-lg-7 col-xl-7">
                <div class="xs-features-api">
                    <span class="hline"></span>
                    <span class="vline"></span>
                    <span class="vline vline2"></span>
                    <div class="row match-box">
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Advanced-Grammar.png" alt="Advanced Grammar" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading ">
                                        <h3>高級文法</h3>
                                    </div>
                                    <p>最適合學術和正式交流
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_ExpertProofreading.png" alt="Subject-specific Corrections" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>特定學科的更正</h3>
                                    </div>
                                    <p>自動學科檢測和精確建議
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_title.png" alt="Contextual Spelling" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>上下文拼寫</h3>
                                    </div>
                                    <p>根據您的學科選擇正確的術語
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Pass_02.png" alt="Tips & Explanations" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>提示和說明</h3>
                                    </div>
                                    <p>為用戶提供可解釋的人工智慧（AI）建議
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Non-standard-2.png" alt="Style Guide Preference" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>風格指南偏好 </h3>
                                    </div>
                                    <p>根據風格指南（AMA、APA等）提出更正建議
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media no-border-before">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Dictionary.png" alt="Custom Dictionaries" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>自定義詞典</h3>
                                    </div>
                                    <p>改進建議並保持品牌
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="use_trinka_other_app accomplishBrilliantWrap mt-0">
    <div class="container">
        <div class="accomplishBrilliantSection">
            <h2>Get writing assistance within your application</h2>
            <a (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons pointer">Contact Us</a>
        </div>
    </div>
</div> -->

<div class="pricing_works">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="brandlogo_heading">
                    <h2>適合您的靈活定價</h2>
                </div>
                <p>我們竭誠為您服務，為您定制最佳定價模式，提供最具性價比的服務。我們支持基於文本量、檔案數量或應用程式介面（API）調用量的定價選項，滿足您的確切需求。</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">

                    <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">獲取報價</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writeToolboxs_section1">
    <div class="writeToolbox_inner_sections1">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>安全、可靠、值得信賴</h3>
                        <p>Trinka將資料安全和隱私放在首位。您的所有資料都經過高度加密並安全存儲，沒有其他人能夠訪問您的資料。我們提供獨有的方案，一旦送給您寫作建議，我們就會完全刪除保存的資料。
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections1 sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>關於人工智慧</h3>
                        <p>Trinka使用最新的機器學習(ML)和自然語言處理(NLP)技術來識別文法錯誤並提出語言改進建議。Trinka是數百萬篇優秀論文和文章的訓練成果。它涵蓋了1300多個學科領域，包括醫學、生命科學、生物學、物理科學、工程、人文、商業和藝術，能為您提供最相關的建議。</p>
                        <p>Trinka由語言學家、醫學編輯、資料科學家和工程師組成的團隊開發而成，他們深切希望透過無障礙溝通創造未來。
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>常見問題</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    文法或拼寫檢查應用程式介面（API）適用於誰？</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <p>我們的文法檢查工具應用程式介面（API）可滿足不同的用途。我們目前的客戶使用它實現如下功能：</p>
                                    <ol>
                                        <li>論文自動評分。</li>
                                        <li>在應用程式的文本編輯器中添加文法檢查功能。</li>
                                        <li>提高編輯服務品質。</li>
                                        <li>檢查網站的文法問題。</li>
                                        <li>為英語學習者提供回饋。</li>
                                        <li>檢查翻譯文本的文法錯誤。</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    我能夠將即時文法檢查功能集成到我的文本編輯器中嗎？</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>將即時文法檢查集成到文本編輯器中是一個常見的用例，因為隨時隨地文法檢查已經成為寫作過程中預期的功能之一。我們構建了一個文法檢查組件，透過它很容易就能將文法檢查集成到任何在線編輯器中。該應用程式介面易於使用，您只需幾分鐘時間就可以將文法和拼寫檢查集成到您的編輯器中。您也可以很容易自定義組件的外觀與您的公司風格相匹配，甚至還可以添加鍵盤快捷鍵和其他自定義項。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    請問免費試用應用程式介面（API）嗎？
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>是的，如果您對我們的應用程式介面（API）有興趣， <a (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup">請與我們聯繫！</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFive">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    應用程式介面（API）是否有詳細的調用文檔？
                                </a>
                            </div>

                            <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                <div class="card-body">
                                    <p>是的！我們提供詳細的應用程式介面（API）文檔和集成支持來幫助您集成Trinka的文法檢查功能。<a (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup">請與我們聯繫！</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionSix">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    如果我們開始使用文法檢查工具應用程式介面（API），是否會產生額外費用？
                                </a>
                            </div>

                            <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                <div class="card-body">
                                    <p>不會，我們不會收取沒有任何形式的安裝費用。<a (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup">開始使用應用程式介面（API）。</a></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>

<div class="modal custom_modal_popup enterprisePopup sampleCode" id="sampleCode">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body">
                <div class="code-block">
                    <div class="closed_icons">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="row no-margin">
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">示例代碼:</h3>
                            <div class="code-bloc">
                            <pre class="html ">
                                <div class="style-4 code">
1 curl --location --request POST
2 <span class="tx-green">'https://check.trinka.ai/languagecheck/v1/check' \</span>
3 --header 'x-api-key: xxxxzxzxzxzxzxzxzxzxz \
4 --header 'Content-Type: application/json' \
5
6 --data-raw '<span class="tx-yellow">&#123;</span>
7 <span class="tx-l-blue">"paragraph"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment.         
<span class="tx-white">8</span>    It is utilized as not only a structural component 
<span class="tx-white">9</span>    but also an interior finishing material that can be directly 
<span class="tx-white">10</span>    seen and touched in different buildings, such as houses, 
<span class="tx-white">11</span>    offices, and public facilities. Moreover, it brings a 
<span class="tx-white">12</span>    positive impression, such as comfort and relaxation, 
<span class="tx-white">13</span>    among residents and users."</span>,
14 <span class="tx-l-blue">"language"</span>: <span class="tx-orange">"US"</span>
15 <span class="tx-yellow">&#125;</span>'
                                </div>
                            </pre>
                            </div>
                        </div>
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">輸出樣本:</h3>
                            <div class="code-bloc">
                            <pre class="html style-4">
                                <div class="style-4 code ">
1 <span class="tx-yellow">&#123;</span>
2    <span class="tx-l-blue">"status"</span>: <span class="tx-d-blue">true</span>,
3   <span class="tx-l-blue">"input_para"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment. It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities. Moreover, it brings a positive impression, such as comfort and relaxation, among residents and users."</span>,
4    <span class="tx-l-blue">"sentences"</span>: <span class="tx-pink">&#91;</span>
5        <span class="tx-d-blue">&#123;</span>
6            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
7            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment."</span>,
8           <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">0</span>,
9            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">54</span>,
10            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
11                <span class="tx-pink">&#123;</span>
12                   <span class="tx-green">/*** Detected issue and its details ***/</span>
13                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">35</span>,
14                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">40</span>,
15                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"indoor"</span>,
16                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
17                        <span class="tx-orange">"the indoor"</span>
18                    <span class="tx-d-blue">&#93;</span>,
19                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
20                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
21                        <span class="tx-orange">"Insert 'a', 'an', or 'the' before 'indoor'."</span>
22                    <span class="tx-d-blue">&#93;</span>,
23                    <span class="tx-green">/*** Error categorization ***/</span>
24                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
25                        <span class="tx-orange">"Grammar-Article"</span>
26                    <span class="tx-d-blue">&#93;</span>,
27                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
28                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
29                        <span class="tx-d-blue">true</span>
30                    <span class="tx-d-blue">&#93;</span>,
31                <span class="tx-pink">&#125;</span>
32            <span class="tx-yellow">&#93;</span>
33        <span class="tx-d-blue">&#125;</span>,
34        <span class="tx-d-blue">&#123;</span>
35            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
36            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities."</span>,
37            <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">55</span>,
38            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">254</span>,
39            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
40                <span class="tx-pink">&#123;</span>
41                    <span class="tx-green">/*** Detected issue and its details ***/</span>
42                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">6</span>,
43                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">13</span>,
44                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"utilized"</span>,
45                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
46                        <span class="tx-orange">"used"</span>
47                    <span class="tx-d-blue">&#93;</span>,
48                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
49                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
50                        <span class="tx-orange">"Plain language tip: Replace \"utilized\" with \"used\" if it fits the context."</span>
51                    <span class="tx-d-blue">&#93;</span>,
52                    <span class="tx-green">/*** Error categorization ***/</span>
53                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
54                        <span class="tx-orange">"Enhancement"</span>
55                    <span class="tx-d-blue">&#93;</span>,
56                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
57                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
58                        <span class="tx-d-blue">true</span>
59                    <span class="tx-d-blue">&#93;</span>,
60                <span class="tx-pink">&#125;</span>
61            <span class="tx-yellow">&#93;</span>
62        <span class="tx-d-blue">&#125;</span>,
63    <span class="tx-pink">&#93;</span>,
64    <span class="tx-l-blue">"message"</span>: <span class="tx-orange">"Success"</span>
65 <span class="tx-yellow">&#125;</span> 
                                </div>
                            </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal custom_modal_popup enterprisePopup" id="EnterPriseContactPopup">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
                <div class="closed_icons">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="contactPopupHeading">
                            <h2>企業客戶諮詢</h2>
                            <p *ngIf="formSection">誰需要我們的服務？</p>
                        </div>
                    </div>
                    <div class="inquiryTypeSection">
                        <ul class="nav nav-tabs" role="tablist" *ngIf="formSection">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#IndividualType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Individual">
                                            <path class="cls-1" d="M44.83,45.13V39.82a4.65,4.65,0,0,0-1.7-3.6,62.85,62.85,0,0,0-10.89-7V22.5a4.4,4.4,0,0,0,1.56-3.36V11.39A7.9,7.9,0,0,0,25.91,3.5H24.24a7.9,7.9,0,0,0-7.89,7.89v7.75a4.32,4.32,0,0,0,1.54,3.36h0v6.68A62.22,62.22,0,0,0,7,36.22a4.62,4.62,0,0,0-1.7,3.6v5.31"
                                            />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>個人用戶</h3>
                                        <span>（單一使用者）</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#OrganizationType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Organization">
                                            <path class="cls-1" d="M42.87,45.13V40.06a4.45,4.45,0,0,0-1.62-3.44,60,60,0,0,0-10.41-6.72V23.51a4.2,4.2,0,0,0,1.49-3.21V12.89a7.55,7.55,0,0,0-7.54-7.54H23.19a7.55,7.55,0,0,0-7.54,7.54V20.3a4.13,4.13,0,0,0,1.47,3.21h0v6.38A59.44,59.44,0,0,0,6.71,36.62a4.42,4.42,0,0,0-1.62,3.44v5.07"
                                            />
                                            <path class="cls-1" d="M14.34,30.75a24.56,24.56,0,0,0-3.32-2V26.18a1.66,1.66,0,0,0,.59-1.27V22a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v2.93a1.63,1.63,0,0,0,.58,1.27h0v2.53a23.54,23.54,0,0,0-4.12,2.66,1.75,1.75,0,0,0-.64,1.36v2"
                                            />
                                            <path class="cls-1" d="M34.29,30.75a24.56,24.56,0,0,1,3.32-2V26.18A1.66,1.66,0,0,1,37,24.91V22a3,3,0,0,1,3-3h.63a3,3,0,0,1,3,3v2.93A1.63,1.63,0,0,1,43,26.18h0v2.53a23.54,23.54,0,0,1,4.12,2.66,1.75,1.75,0,0,1,.64,1.36v2"
                                            />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>企業或單位</h3>
                                        <span>（多個用戶）</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane" id="IndividualType" role="tabpanel" *ngIf="formSection">
                                <div class="IndividualTypeSection">
                                    <p>Trinka對於個人用戶是免費的，您只需註冊您的電子郵箱地址即可。</p>
                                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊</a>
                                </div>
                            </div>
                            <div class="tab-pane" id="OrganizationType" role="tabpanel" *ngIf="formSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="contact_us_form">
                                            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                                <h2>請在下面提出您的要求，我們的團隊將及時回復。</h2>
                                                <div class="row">
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>業務性質*</mat-label>
                                                                <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>單位名稱*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox" [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <label for="">請告訴我們您的要求</label>
                                                            <textarea formControlName="contactFormMessage" class="form-control" placeholder="例如。大約的用戶數，每個用戶的每月處理字數，所需的自訂設置等。"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>您的姓名*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>指定*</mat-label>
                                                                <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>電子郵件*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>聯絡電話（包括國際代碼）</mat-label>
                                                                <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group text-center">
                                                    <button type="submit">送出</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="thank_section contact_us_form" *ngIf="thankSection">
                                <div class="form-group">
                                    <h2>感謝您！</h2>
                                    <p>我們會儘快和您聯絡。</p>
                                    <!-- <button data-dismiss="modal">Close</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>